import { RedoCheckbox } from "@redotech/arbiter/checkbox/redo-checkbox";

export function ShowHiddenRecoverFieldsField({
  value,
  setValue,
}: {
  value: boolean;
  setValue: (value: boolean) => void;
}) {
  return (
    <RedoCheckbox
      label="Show hidden fields"
      setValue={(value) => setValue(value === true)}
      size="xs"
      value={value}
    />
  );
}
